/**
 * USE GEOLOCATION HOOK
 * 
 * React hook to detect user's country from IP address.
 * Returns detected country for SUGGESTION (not auto-selection).
 */

import { useState, useEffect } from 'react';
import { detectUserCountry, GeoLocationResult } from '../services/geolocationService';

interface UseGeolocationResult {
 detectedCountry: GeoLocationResult | null;
 loading: boolean;
 error: string | null;
 refetch: () => Promise<void>;
}

export function useGeolocation(autoDetect: boolean = true): UseGeolocationResult {
 const [detectedCountry, setDetectedCountry] = useState<GeoLocationResult | null>(null);
 const [loading, setLoading] = useState(autoDetect);
 const [error, setError] = useState<string | null>(null);

 const fetchLocation = async () => {
 setLoading(true);
 setError(null);

 try {
 const result = await detectUserCountry();
 setDetectedCountry(result);
 } catch (err) {
 console.error('Geolocation detection failed:', err);
 setError('Could not detect your location');
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 if (autoDetect) {
 fetchLocation();
 }
 }, [autoDetect]);

 return {
 detectedCountry,
 loading,
 error,
 refetch: fetchLocation
 };
}

export default useGeolocation;

